import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "list-group list-group-flush my-n3" }

import CaptionListItem from '@/components/CaptionListItem.vue';
import ChargeSpeedIcon from '@/components/ChargeSpeedIcon.vue';
import { EChargingSpeedType } from '@/enums';


export default /*@__PURE__*/_defineComponent({
  __name: 'Captions',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_AppContainer = _resolveComponent("AppContainer")!

  return (_openBlock(), _createBlock(_component_AppContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageTitle, { title: "Legenda" }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CaptionListItem, null, {
          icon: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "fas fa-circle text-success" }, null, -1)
          ])),
          title: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Conector Disponível")
          ])),
          _: 1
        }),
        _createVNode(CaptionListItem, null, {
          icon: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "fas fa-circle text-danger" }, null, -1)
          ])),
          title: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" Conector Em uso")
          ])),
          _: 1
        }),
        _createVNode(CaptionListItem, null, {
          icon: _withCtx(() => _cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fas fa-circle text-muted" }, null, -1)
          ])),
          title: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode(" Conector Indisponível")
          ])),
          _: 1
        }),
        _createVNode(CaptionListItem, null, {
          icon: _withCtx(() => [
            _createVNode(ChargeSpeedIcon, {
              "speed-type": _unref(EChargingSpeedType).slow
            }, null, 8, ["speed-type"])
          ]),
          title: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode(" Carga normal (7 até 22kW)")
          ])),
          _: 1
        }),
        _createVNode(CaptionListItem, null, {
          icon: _withCtx(() => [
            _createVNode(ChargeSpeedIcon, {
              "speed-type": _unref(EChargingSpeedType).fast
            }, null, 8, ["speed-type"])
          ]),
          title: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode(" Carga rápida (40 até 60kW)")
          ])),
          _: 1
        }),
        _createVNode(CaptionListItem, null, {
          icon: _withCtx(() => [
            _createVNode(ChargeSpeedIcon, {
              "speed-type": _unref(EChargingSpeedType).ultra
            }, null, 8, ["speed-type"])
          ]),
          title: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode(" Carga últra rápida (80 até 150kW)")
          ])),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})